import { authHeader } from "../auth/authHeader";
import axios from "axios";
import { userService } from "./user.services";

const ERROR_MESSAGES = {
  save: "Chyba při ukládání dat",
  load: "Chyba při načítání dat",
};

const getLaboratoryAreas = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/complement/laboratory-areas/",
      { ...options, params: { ...params } }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

const getLaboratoryArea = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + `/complement/laboratory-areas/${id}/`,
      { ...options }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

const getParameterDefinitions = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/complement/parameter-definitions/",
      { ...options, params: { ...params } }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

const getParameterDefinition = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API +
        `/complement/parameter-definitions/${id}/`,
      { ...options }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

const updateParameterDefinition = async (id, data) => {
  const options = authHeader("PATCH");
  try {
    const response = await axios.patch(
      process.env.REACT_APP_ROOT_API +
        `/complement/parameter-definitions/${id}/`,
      data,
      { ...options }
    );
    return response;
  } catch (error) {
    error.message = ERROR_MESSAGES.save;
    return handleError(error);
  }
};

const getParameterResults = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/complement/parameter-results/",
      { ...options, params: { ...params } }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

const getSamplings = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + `/complement/samplings`,
      { ...options, params: { ...params } }
    );
    return response.data;
  } catch (error) {
    error.message = ERROR_MESSAGES.load;
    return handleError(error);
  }
};

function handleError(error) {
  if (error.response && error.response.status === 401) {
    userService.logout();
    window.location.replace("/signin");
  }

  return Promise.reject(error);
}

export const laboratoryService = {
  getLaboratoryAreas,
  getLaboratoryArea,
  getParameterDefinitions,
  getParameterDefinition,
  updateParameterDefinition,
  getParameterResults,
  getSamplings,
};
